import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { Table, Alert, Spin } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import { Link } from "react-router-dom";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import "./assets/css/ReviewsMy.css"; // Adicionar um arquivo CSS para estilizar

const ReviewsMy = () => {

  document.title = "Minhas Avaliações | Plantão Rápido";
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0, lastPage: 0 });
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchRatings();
  }, [pagination.current, pagination.pageSize]);

  const fetchRatings = async () => {
    setError(null);
    try {
      const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}users/rating-list`, {
        per_page: pagination.pageSize,
        page: pagination.current,
      }, true);

      const { data, pagination: pagInfo } = ApiService.handleApiResponse(response);
      setData(data || []);
      setPagination(pagInfo || { current: 1, pageSize: 10, total: 0 });


    } catch (error) {
      ApiService.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Usuário/Empresa",
      dataIndex: "rated_user_info",
      render: (rated_user_info) => (
          <>
            <a className="avatar mx-2" href={`/admin/detail/${rated_user_info.url_page}`}>
              <img className="rounded-circle" src={rated_user_info.profile_image} alt={rated_user_info.name} />
            </a>
            <a target="_blank" href={`/admin/detail/${rated_user_info.url_page}`}>{rated_user_info.name}</a>
          </>
      ),
      sorter: (a, b) => a.rated_user_info.name.localeCompare(b.rated_user_info.name),
      width: 200,
    },
    {
      title: "Comentário",
      dataIndex: "comment",
      render: (text) => (
          <p style={{ whiteSpace: "normal", wordWrap: "break-word", marginBottom: 0 }}>
            {text || "Nenhuma descrição disponível"}
          </p>
      ),
      sorter: (a, b) => (a.comment || "").localeCompare(b.comment || ""),
      width: 'auto',
    },
    {
      title: "Avaliação",
      dataIndex: "rating",
      render: (rating) => (
          <span>
          {[...Array(5)].map((_, i) => (
              <i key={i} className={`fe fe-star ${i < rating ? "text-warning" : "text-secondary"}`}></i>
          ))}
        </span>
      ),
      width: 150,
    },
    {
      title: "Data",
      render: (record) => <span>{new Date(record.created_at).toLocaleString()}</span>,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      width: 180,
    }
  ];

  return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title="Minhas" pageTitle="Avaliações"/>
            <Row>
                      <Table
                          loading={loading}
                          columns={columns}
                          locale={{
                            emptyText: 'Nenhum dado disponível',
                          }}
                          dataSource={data}
                          rowKey={(record) => record.id}
                          pagination={false}
                          className="responsive-table"
                      />

                    <CustomPagination
                        pagination={pagination}
                        onChange={(page) => setPagination({ ...pagination, current: page })}
                    />

            </Row>
          </Container>
        </div>
      </React.Fragment>


  );
};

export default ReviewsMy;
